import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

// let abortControllerFetchSuppliers = null;

/**
 * Gọi API lấy danh sách nhà cung cấp
 * @param values
 * @param values.textureType []{ stone | glass | tile | wood }
 */
export const fetchSuppliers = createAsyncThunk(
  'get/suppliers/v3/suppliers',
  async ({ textureType }, { dispatch }) => {
    try {
      // if (abortControllerFetchSuppliers) {
      //   abortControllerFetchSuppliers.abort();
      // }
      // abortControllerFetchSuppliers = new AbortController();

      const res = await callApi({
        endpoint: 'suppliers/v3/suppliers',
        method: 'get',
        params: { texture_type: textureType },
        // signal: abortControllerFetchSuppliers.signal,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { [textureType]: data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);
